/** 
 * api接口的统一出口
 */
//公共方法js
import common from '@/request/api/common.js'
//商品模块接口
import goods from '@/request/api/goods/goods'
//独立版商品模块接口
import goodsAlone from '@/request/api/goods/goods_alone'
//用户模块接口
import user from '@/request/api/user/user'
//订单模块接口
import order from '@/request/api/order/order'
//独立版订单模块接口
import orderAlone from '@/request/api/order/order_alone'
//独立版验货单模块接口
import examinGoodsAlone from '@/request/api/order/examinGoods_alone'
//购物车模块接口
import bucket from '@/request/api/bucket/bucket'
//独立版购物车模块接口
import bucketAlone from '@/request/api/bucket/bucket_alone'
//优惠券模块接口
import coupon from '@/request/api/coupon/coupon'
//品牌汇模块接口
import brandRemit from '@/request/api/brandRemit/brandRemit'

//积分兑换相关接口
import integral from '@/request/api/integral/integral'

//积分兑换相关接口
import bonus from '@/request/api/integral/bonus'

//小程序定制化入口
import miniProgram from '@/request/api/miniProgram/miniProgram'

// 首页
import homePage from '@/request/api/homePage/homePage'
//收银

// 对接版验货接口
import examinGoods from '@/request/api/order/examinGoods'

// 导出接口
export default {
    common,
    goods,
    user,
    order,
    bucket,
    coupon,
    brandRemit,
    integral,
    bonus,
    miniProgram,
    homePage,
    goodsAlone,
    bucketAlone,
    orderAlone,
    examinGoodsAlone,
    examinGoods
}


// WEBPACK FOOTER //
// ./src/request/api/index.js